import { lazy, useMemo } from 'react';

import SuspenseWrapper from '~/components/misc/suspense-wrapper';

import { PROVIDERS } from './constants';
import ExternalProvider from './context';

const MitidProvider = lazy(() => import('./mitid'));

const ProviderResolver = ({ provider }) => {
	switch (provider) {
		case PROVIDERS.MITID:
			return <MitidProvider />;
		default:
			return null;
	}
};

const ExternalProviders = config => {
	const { endPoints, meta = {}, onComplete, provider = null } = config;

	const contextValue = useMemo(
		() => ({
			endPoints,
			meta,
			onComplete,
			provider
		}),
		[endPoints, meta, onComplete, provider]
	);

	if (provider === null) {
		return null;
	}

	return (
		<ExternalProvider value={contextValue}>
			<SuspenseWrapper withSuspense>
				<ProviderResolver provider={provider} />
			</SuspenseWrapper>
		</ExternalProvider>
	);
};

export default ExternalProviders;
